import * as React from "react";
import { routeConfig } from "../../../../config/language/ja-JP/presentation/route_text";
import { Company } from "../../../../domain/model/company";
import { Customer } from "../../../../domain/model/customer";
import { JobCareer } from "../../../../domain/model/job_career";
import { PastCaseProject } from "../../../../domain/model/past_case_project";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import Progress from "../../../common/organism/progress";
import { TBreadcrumbItem } from "../../../type/common";
import ClientCustomerMainV2 from "./client_customer_main_v2";

interface IProps {
  isInit: boolean;
  isLoading: boolean;
  customer: Customer | null;
  jobCareers: JobCareer[];
  company: Company | null;
  pastCaseProjects: PastCaseProject[];
}

const ClientCustomerComponent: React.FC<IProps> = (props) => {
  const { isInit, isLoading, customer, jobCareers, company, pastCaseProjects } =
    props;

  // 初期化
  if (isInit) {
    return <Progress canAnimation={false} />;
  }

  const breadcrumbItems: TBreadcrumbItem[] = [
    routeConfig.clientRoot,
    { text: `プロフィール` },
  ];

  return (
    <React.Fragment>
      {isLoading && <Progress canAnimation={false} />}
      <PageWrapper>
        <Breadcrumbs breadcrumbItems={breadcrumbItems} />

        <ClientCustomerMainV2
          customer={customer}
          jobCareers={jobCareers}
          pastCaseProjects={pastCaseProjects}
          company={company}
        />
      </PageWrapper>
    </React.Fragment>
  );
};

export default ClientCustomerComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/customer/client_customer.tsx